import "./StackHolder.css"

const StackHolder = ({children}) => {
    return (
        <div className={"staque-holder"}>
            {children}
        </div>
    );
}


export default StackHolder;